 
<div class="div-fix"> 
    <form [formGroup]="dateForm"  class="row row-padding" (submit)="onSubmitDates()">
    <div class="col-2"> 
      <mat-form-field  class="mat-date-pick">
        <mat-label>Plate No.</mat-label>
        <input matInput formControlName="plateNo"/>
        <!-- <mat-error *ngIf="dateForm.get('plateNo').hasError('required')">
           Please enter
           <strong>plate Number</strong> 
         </mat-error>-->
     </mat-form-field>
    </div>
    <div class="col-3"> 
     <mat-form-field  class="mat-date-pick">
      <mat-label>Start date</mat-label>
      <input matInput (click)="picker.open()" [min]="minDate" [matDatepicker]="picker" formControlName="startDate" 
       novalidate>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error *ngIf="dateForm.get('startDate').hasError('required')">
        Please enter date format
      </mat-error>
    </mat-form-field>
        <!-- <mat-form-field  class="mat-date-pick">
            <mat-label>End date</mat-label>
            <input matInput [matDatepicker]="picker1" formControlName="endDate"
            [min]="dateForm.controls['startDate'].value? dateForm.controls['startDate'].value : maxDate"  novalidate>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>                      -->
    </div>
    <div class="col-3"> 
         <mat-form-field  class="mat-date-pick">
             <mat-label>End date</mat-label>
             <input matInput [min]="minDate" [matDatepicker]="picker1" formControlName="endDate"
             [min]="dateForm.controls['startDate'].value? dateForm.controls['startDate'].value : maxDate"  novalidate>
             <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
             <mat-datepicker #picker1></mat-datepicker>
           </mat-form-field>                     
     </div>
    <div class="col-2" style="width:100%;">
      <mat-form-field class="mat-date-pick">
          <mat-label>Street</mat-label>
          <mat-select formControlName="street">
            <mat-option [value]="street.id" *ngFor="let street of streets">{{street.street}}</mat-option>
          </mat-select>
        </mat-form-field>
    </div>
    <div class="col-3 display-flex">
        <button mat-button class="button-primary no-top-margins btn-search"  color="vov-ui-primary">Search Waivers</button>
        <span ><button style="padding: 22px;" type="reset" class="semi-button semi-reset"  color="vov-ui-primary" (click)="reset()">Reset</button></span> 
    </div>
</form>

  </div> 

  <p  class="sub-form-title no-margin">Waivers Table</p>

  <app-spinner *ngIf="showSpinner; else content"></app-spinner>   
  <ng-template #content>

  <div class = "box wavier-table" *ngIf="waviers.length;"> 
    <div class="export-button">
      <button mat-button  [disabled]="!waviers.length" (click)="exportAsXLSX()" color="vov-ui-primary"><i class="fa fa-upload" aria-hidden="true"></i>Export CSV</button>
      </div>
    <app-table [tableData]="waviers"  (rowSelected)="selectedItems($event)" [tableColumnsNames]="columnNames"></app-table> 
  </div>
  <p *ngIf="waviers.length == 0">No Data Found</p>       
   </ng-template> 
   <!-- <ng-template #confirmRef>
    <div class="dialog-Container">
      <h3 mat-dialog-title>Are you sure you want to update?</h3>
      <mat-dialog-content class="delete-Conatiner">
        <button mat-button color="vov-ui-primary" class="confirm-btn confirm" (click)="confirmUpdate()">Update</button>
        <button mat-button (click)="onNoClick()" class="confirm-btn cancel" tabindex="-1">Cancel</button>
      </mat-dialog-content>
    </div>
  </ng-template> -->

  <ng-template #confirmRef>
    <div class="dialog-Container">
      <mat-dialog-actions class="d-inline-block float-right">
        <h4 class="d-inline-block">Update Waiver Limit</h4>
        <button mat-dialog-close class="dialog-btn-trans text-white">X</button>
      </mat-dialog-actions>
      <mat-dialog-content class="dialog-content">
        <!-- <p class="sub-form-title mandator-title dialog-sub-title">* All fields are required</p> -->
        <form class="address-form" action="" [formGroup]="updateWaiverForm" (submit)="confirmUpdate()">
          <mat-form-field appearance="fill">
            <mat-label>Waiver Limit</mat-label>
            <input type="number" [min]="1" [max]="99" (keydown)="numberOnly($event)" matInput formControlName="waiverCount" required />
            <mat-error *ngIf="updateWaiverForm.get('waiverCount').hasError('required')">
              Please enter limit
            </mat-error>
          </mat-form-field>
          <!-- <button mat-button *ngIf="!selectedItem" class="button-primary" [disabled]='yearCycleForm.invalid' type="submit"
            color="vov-ui-primary">Submit</button> -->
          <button mat-button class="button-primary" [disabled]='updateWaiverForm.invalid' type="submit"
             color="vov-ui-primary">Update</button>
        </form>
      </mat-dialog-content>
    </div>
  </ng-template>